import { Box } from "@mui/material";

// import InputAdornment from "@mui/material/InputAdornment";
import { useState, useEffect } from "react";

import { XyzTransition } from "@animxyz/react";
import "@animxyz/core";

import PixPay from "../../components/pix-vaue-pay";
import PixMail from "../../components/pix-email-pay";
import PixGerado from "../../components/pix-gerado";

import { addTransaction } from "../../utils/firebase/firebase.datatable";

import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../store/user/user.selector";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import useMediaQuery from "@mui/material/useMediaQuery";

import { signOutUser } from '../../utils/firebase/firebase'

const Pix = () => {
	const isNonMobile = useMediaQuery("(min-width: 800px)");
	const user = useSelector(selectCurrentUser);
	const [value, setValue] = useState("");
	const [clientMail, setClientMail] = useState("");
	const [step, setStep] = useState(0);
	const [isValidMail, setValidMail] = useState(false);
	const MySwal = withReactContent(Swal);
	const [productsSell, setProductsSell] = useState([]);
	const [producttoSellList, setProductToSellList] = useState([]);

	useEffect(() => {
		const totalValueCart = productsSell.reduce(
			(total, product) => total + product.valor,
			0
		);
		setValue(totalValueCart);
	}, [productsSell]);

	const handlerChangeCurrency = event => {
		if (event) {
			const setVal = parseFloat(event.replace(",", ".")).toFixed(2);
			setValue(setVal);
		} else {
			setValue("");
		}
	};

	const handleStep = async () => {
		const stepPlus = step + 1;
		setStep(stepPlus);
		if (stepPlus > 1) {
			console.log("salvar transacao");
			try {
				const newTrans = await addTransaction(
					user.displayName,
					user.email,
					user.uid,
					"pix",
					value,
					"1",
					clientMail,
					producttoSellList
				);
				if(!newTrans) {
					signOutUser()
				}
			} catch (err) {
				console.log("Problema salvar: ", err);
			}
			
		}
	};

	const regexMail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	const handleChangeEmail = event => {
		setClientMail(event.target.value);
		if (event.target.value.match(regexMail)) {
			setValidMail(true);
		} else {
			setValidMail(false);
		}
	};

	const handleInputChangeProducts = (event, newValue) => {
		if(event.type === 'click') {
			if(newValue?.codigo){
				setProductsSell([...productsSell, {codigo: newValue.codigo, id: newValue.id, valor: newValue.valor}])
			}
		}
	};

	const handleRemoveProduct = (product, index) => {
		const products = [ ...productsSell]
		products.splice(index, 1)
		setProductsSell(products)
		
	}

	useEffect(() => {
		setProductToSellList(productsSell.map((e) => e.codigo))
	},[productsSell])


	return (
		<Box
			display="flex"
			justifyContent={step === 0 ? 'start' : 'center'}
			alignItems="center"
			flexDirection="column"
			sx={{
				margin: "0 auto",
				width: !isNonMobile ? "95%" : "50%",
				height: "100%"
				// backgroundColor: "white"
			}}
		>
			<XyzTransition appear mode="out-in" xyz="fade ease right-5">
				{/* STEP 0 - VALOR A PAGAR */}
				{step === 0 &&
					<Box
						sx={{
							width: "100%",
						}}
					>
						<PixPay
							handlerChangeCurrency={handlerChangeCurrency}
							value={value}
							handleStep={handleStep}
							handleInputChangeProducts={handleInputChangeProducts}
							productsSell={productsSell}
							handleRemoveProduct={handleRemoveProduct}
							xyz="fade ease right-5"
						/>
					</Box>}

				{/* STEP 2 - EMAIL CLIENTE */}
				{step === 1 &&
					<Box
						sx={{
							width: "100%"
						}}
						xyz="fade ease right-5"
					>
						<PixMail
							handleChangeEmail={handleChangeEmail}
							clientMail={clientMail}
							isValidMail={isValidMail}
							handleStep={handleStep}
						/>
					</Box>}

				{step === 2 &&
					<Box
						sx={{
							width: "100%"
						}}
					>
						<PixGerado
							value={value}
							email={clientMail}
							MySwal={MySwal}
						/>
					</Box>}
			</XyzTransition>
		</Box>
	);
};

export default Pix;
